<template>
    <body>
        <main app="">
            <span>
                <div class="parallax" dark="">
                    <div class="parallax__image-container">
                        <img
                            src="https://res.cloudinary.com/storagemanagementcontainer/image/upload/c_scale,h_500,w_1500/v1649549249/nft/animeskatergirl_hgv1a4.png"
                            class="parallax__image"
                            style="display: block; opacity: 1"
                        />
                    </div>
                    <div class="parallax__content">
                        <div class="container">
                            <div class="jumbotron" style="height: 100%">
                                <div class="jumbotron__wrapper">
                                    <div class="jumbotron__background"></div>
                                    <div class="jumbotron__content">
                                        <div
                                            class="layout lighten-1 home-transparent row ma-2 blue-light-background"
                                        >
                                            <div
                                                class="flex text-xs-center xs12"
                                            >
                                                <h1
                                                    class="ma-3 title-header"
                                                    style="color: white"
                                                >
                                                    Seikatsu
                                                </h1>
                                                <p>
                                                    an NFT art collection that
                                                    tells the history of
                                                    Ethereum.
                                                    <br />
                                                    ~ Established 2022 ~
                                                </p>
                                            </div>
                                        </div>
                                        <div class="layout row wrap align-top">
                                            <div
                                                class="flex xs12 sm12 md3 lg3 pt-2 pb-2 px-2"
                                            >
                                                <span
                                                    class="tooltip tooltip--bottom"
                                                    ><span
                                                        ><div
                                                            class="lighten-1 home-transparent px-2 py-2 card card--flat"
                                                            style="
                                                                height: 100%;
                                                                border-radius: 16px;
                                                            "
                                                        >
                                                            <h2 class="pa-2">
                                                                <i
                                                                    aria-hidden="true"
                                                                    class="icon cyanBlue--text text--lighten-1 material-icons"
                                                                    style="
                                                                        font-size: 36px;
                                                                    "
                                                                    >fingerprint</i
                                                                >
                                                                Unique artwork
                                                            </h2>
                                                        </div></span
                                                    ></span
                                                >
                                            </div>
                                            <div
                                                class="flex xs12 sm12 md3 lg3 pt-2 pb-2 px-2"
                                            >
                                                <span
                                                    class="tooltip tooltip--bottom"
                                                    ><span
                                                        ><div
                                                            class="lighten-1 home-transparent px-2 py-2 card card--flat"
                                                            style="
                                                                height: 100%;
                                                                border-radius: 16px;
                                                            "
                                                        >
                                                            <h2 class="pa-2">
                                                                <i
                                                                    aria-hidden="true"
                                                                    class="icon cyanBlue--text text--lighten-1 material-icons"
                                                                    style="
                                                                        font-size: 36px;
                                                                    "
                                                                    >access_time</i
                                                                >
                                                                Historical
                                                                collection
                                                            </h2>
                                                        </div></span
                                                    ></span
                                                >
                                            </div>
                                            <div
                                                class="flex xs12 sm12 md3 lg3 pt-2 pb-2 px-2"
                                            >
                                                <span
                                                    class="tooltip tooltip--bottom"
                                                    ><span
                                                        ><div
                                                            class="lighten-1 home-transparent px-2 py-2 card card--flat"
                                                            style="
                                                                height: 100%;
                                                                border-radius: 16px;
                                                            "
                                                        >
                                                            <h2 class="pa-2">
                                                                <i
                                                                    aria-hidden="true"
                                                                    class="icon cyanBlue--text text--lighten-1 material-icons"
                                                                    style="
                                                                        font-size: 36px;
                                                                        border-radius: 16px;
                                                                    "
                                                                    >photo</i
                                                                >
                                                                Signed prints
                                                            </h2>
                                                        </div></span
                                                    ></span
                                                >
                                            </div>
                                            <div
                                                class="flex xs12 sm12 md3 lg3 pt-2 pb-2 px-2"
                                            >
                                                <span
                                                    class="tooltip tooltip--bottom"
                                                    ><span
                                                        ><div
                                                            class="lighten-1 home-transparent px-2 py-2 card card--flat"
                                                            style="
                                                                height: 100%;
                                                                border-radius: 16px;
                                                            "
                                                        >
                                                            <h2 class="pa-2">
                                                                <i
                                                                    aria-hidden="true"
                                                                    class="icon cyanBlue--text text--lighten-1 material-icons"
                                                                    style="
                                                                        font-size: 36px;
                                                                    "
                                                                    >lock</i
                                                                >
                                                                Blockchain
                                                                powered
                                                            </h2>
                                                        </div></span
                                                    ></span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="layout mt-2 row">
                    <div class="flex xs12">
                        <div class="card" style="height: auto">
                            <div class="container fluid">
                                <div class="layout">
                                    <div class="flex pa-3">
                                        <h3>
                                            The Seikatsu collection is sold out.
                                            Check out
                                            <a
                                                href="https://opensea.io/collection/CryptoArte"
                                                target="_blank"
                                                >paintings available for
                                                purchase at OpenSea</a
                                            >.
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="layout row mb-3 mt-2">
                    <div class="flex text-xs-center xs12">
                        <div class="card" style="height: auto">
                            <div class="layout">
                                <div class="flex">
                                    <div
                                        class="card card--flat"
                                        style="height: auto"
                                    >
                                        <div
                                            class="container fluid grid-list-md"
                                        >
                                            <div
                                                class="layout row justify-center align-center mt-2 mb-2"
                                            >
                                                <button
                                                    disabled="disabled"
                                                    type="button"
                                                    class="btn btn--disabled btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-double-left"
                                                        ></i>
                                                    </div>
                                                </button>
                                                <button
                                                    disabled="disabled"
                                                    type="button"
                                                    class="btn btn--disabled btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-left"
                                                        ></i>
                                                    </div>
                                                </button>
                                                <div
                                                    align-center=""
                                                    class="card__title"
                                                >
                                                    <h1>In the beginning</h1>
                                                    <!---->
                                                    <!---->
                                                </div>
                                                <button
                                                    type="button"
                                                    class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                    mt-4=""
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-right material-icons"
                                                            style="
                                                                display: flex;
                                                            "
                                                            >keyboard_arrow_right</i
                                                        >
                                                    </div>
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                    mt-4=""
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-right material-icons"
                                                            style="
                                                                display: flex;
                                                            "
                                                            >keyboard_double_arrow_right</i
                                                        >
                                                    </div>
                                                </button>
                                            </div>
                                            <div
                                                class="layout row justify-center align-center mt-0 mb-0"
                                            >
                                                <div
                                                    class="menu"
                                                    style="display: block"
                                                >
                                                    <div
                                                        class="menu__activator"
                                                    >
                                                        <div
                                                            class="input-group input-group--dirty input-group--prepend-icon input-group--text-field primary--text"
                                                        >
                                                            <label
                                                                >Go to
                                                                date...</label
                                                            >
                                                            <div
                                                                class="input-group__input"
                                                            >
                                                                <i
                                                                    aria-hidden="true"
                                                                    class="icon material-icons input-group__prepend-icon"
                                                                    >event</i
                                                                ><input
                                                                    tabindex="0"
                                                                    aria-label="Go to date..."
                                                                    type="text"
                                                                />
                                                            </div>
                                                            <div
                                                                class="input-group__details"
                                                            >
                                                                <!---->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="layout row wrap">
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/0"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="
                                                            height: 550px;
                                                            font-family: disposabledroid-bb;
                                                        "
                                                        ><div
                                                            class="card__text"
                                                            style="
                                                                font-family: disposabledroid-bb;
                                                            "
                                                        >
                                                            <h5
                                                                class="ma-0"
                                                                style="
                                                                    font-family: disposabledroid-bb;
                                                                    font-size: 36px;
                                                                "
                                                            >
                                                                Painting #0
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks 0 -
                                                                575</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 400px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url(https://res.cloudinary.com/storagemanagementcontainer/image/upload/c_scale,w_390/v1649551657/nft/seikatsu_small_zqq5xl.jpg)
                                                                        no-repeat;
                                                                    background-size: auto;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/1"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="ma-0"
                                                                style="
                                                                    font-family: disposabledroid-bb;
                                                                    font-size: 36px;
                                                                "
                                                            >
                                                                Painting #1
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks 576 -
                                                                1,151</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 400px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url(https://res.cloudinary.com/storagemanagementcontainer/image/upload/c_scale,w_416/v1649551999/nft/skater2_fzmvqf.png
                                                                            no-repeat;
                                                                            background-size: auto;;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/2"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="ma-0"
                                                                style="
                                                                    font-family: disposabledroid-bb;
                                                                    font-size: 36px;
                                                                "
                                                            >
                                                                Painting #2
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks 1,152 -
                                                                1,727</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 400px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url('https://res.cloudinary.com/storagemanagementcontainer/image/upload/c_scale,w_449/v1649552230/nft/skater3_fjyvsr.png')
                                                                        center
                                                                        center /
                                                                        contain
                                                                        no-repeat;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/3"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="ma-0"
                                                                style="
                                                                    font-family: disposabledroid-bb;
                                                                    font-size: 36px;
                                                                "
                                                            >
                                                                Painting #3
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks 1,728 -
                                                                2,303</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 400px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url(https://res.cloudinary.com/storagemanagementcontainer/image/upload/c_scale,w_463/v1649695570/nft/skater4_uaj2c9.png)
                                                                        no-repeat;
                                                                    background-size: auto;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/4"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="ma-0"
                                                                style="
                                                                    font-family: disposabledroid-bb;
                                                                    font-size: 36px;
                                                                "
                                                            >
                                                                Painting #4
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks 2,304 -
                                                                2,879</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 400px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url(https://res.cloudinary.com/storagemanagementcontainer/image/upload/c_scale,w_466/v1649696036/nft/skater9_ktc4jh.png)
                                                                        no-repeat;
                                                                    background-size: auto;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/5"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="ma-0"
                                                                style="
                                                                    font-family: disposabledroid-bb;
                                                                    font-size: 36px;
                                                                "
                                                            >
                                                                Painting #5
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks 2,880 -
                                                                3,455</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 400px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url(https://res.cloudinary.com/storagemanagementcontainer/image/upload/c_scale,w_442/v1649695298/nft/skater7_y4cctm.png)
                                                                        no-repeat;
                                                                    background-size: auto;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="layout row">
                    <div class="flex text-xs-center xs12">
                        <div class="card" style="height: auto">
                            <div class="layout">
                                <div class="flex">
                                    <div
                                        class="card card--flat"
                                        style="height: auto"
                                    >
                                        <div
                                            class="container fluid grid-list-md"
                                        >
                                            <div
                                                class="layout row justify-center align-center mt-2 mb-2"
                                            >
                                                <button
                                                    type="button"
                                                    class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                    mt-4=""
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-right material-icons"
                                                            style="
                                                                display: flex;
                                                            "
                                                            >keyboard_arrow_right</i
                                                        >
                                                    </div>
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                    mt-4=""
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-right material-icons"
                                                            style="
                                                                display: flex;
                                                            "
                                                            >keyboard_arrow_right</i
                                                        >
                                                    </div>
                                                </button>
                                                <div
                                                    align-center=""
                                                    class="card__title"
                                                >
                                                    <!---->
                                                    <h1>Latest</h1>
                                                    <!---->
                                                </div>
                                                <button
                                                    type="button"
                                                    class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                    mt-4=""
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-right material-icons"
                                                            style="
                                                                display: flex;
                                                            "
                                                            >keyboard_double_arrow_right</i
                                                        >
                                                    </div>
                                                </button>
                                                <button
                                                    disabled="disabled"
                                                    type="button"
                                                    class="btn btn--disabled btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                    mt-4=""
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-right material-icons"
                                                            style="
                                                                display: flex;
                                                            "
                                                            >keyboard_double_arrow_right</i
                                                        >
                                                    </div>
                                                </button>
                                            </div>
                                            <div
                                                class="layout row justify-center align-center mt-0 mb-0"
                                            >
                                                <div
                                                    class="menu"
                                                    style="display: block"
                                                >
                                                    <div
                                                        class="menu__activator"
                                                    >
                                                        <div
                                                            class="input-group input-group--dirty input-group--prepend-icon input-group--text-field primary--text"
                                                        >
                                                            <label
                                                                >Go to
                                                                date...</label
                                                            >
                                                            <div
                                                                class="input-group__input"
                                                            >
                                                                <i
                                                                    aria-hidden="true"
                                                                    class="icon material-icons input-group__prepend-icon"
                                                                    >event</i
                                                                ><input
                                                                    tabindex="0"
                                                                    aria-label="Go to date..."
                                                                    type="text"
                                                                />
                                                            </div>
                                                            <div
                                                                class="input-group__details"
                                                            >
                                                                <!---->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="layout row wrap">
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/9889"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="ma-0"
                                                                style="
                                                                    font-family: disposabledroid-bb;
                                                                    font-size: 36px;
                                                                "
                                                            >
                                                                Painting #9889
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks
                                                                5,696,064 -
                                                                5,696,639</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 400px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url(https://res.cloudinary.com/storagemanagementcontainer/image/upload/c_scale,w_477/v1649695301/nft/skater5.ong_oflldi.png)
                                                                        no-repeat;
                                                                    background-size: auto;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/9890"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="ma-0"
                                                                style="
                                                                    font-family: disposabledroid-bb;
                                                                    font-size: 36px;
                                                                "
                                                            >
                                                                Painting #9890
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks
                                                                5,696,640 -
                                                                5,697,215</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 400px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url(https://res.cloudinary.com/storagemanagementcontainer/image/upload/c_scale,w_488/v1649695577/nft/skater8_rhgrc2.png
                                                                            no-repeat;
                                                                            background-size: auto;;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/9891"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="ma-0"
                                                                style="
                                                                    font-family: disposabledroid-bb;
                                                                    font-size: 36px;
                                                                "
                                                            >
                                                                Painting #9891
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks
                                                                5,697,216 -
                                                                5,697,791</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 400px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url(https://res.cloudinary.com/storagemanagementcontainer/image/upload/c_scale,w_465/v1649695300/nft/skater6_e4vrpf.png)
                                                                        no-repeat;
                                                                    background-size: auto;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/9892"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="ma-0"
                                                                style="
                                                                    font-family: disposabledroid-bb;
                                                                    font-size: 36px;
                                                                "
                                                            >
                                                                Painting #9892
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks
                                                                5,697,792 -
                                                                5,698,367</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 400px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url(https://res.cloudinary.com/storagemanagementcontainer/image/upload/c_scale,w_491/v1649696035/nft/skater10_ztif3e.png
                                                                            no-repeat;
                                                                            background-size: auto;;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/9893"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="ma-0"
                                                                style="
                                                                    font-family: disposabledroid-bb;
                                                                    font-size: 36px;
                                                                "
                                                            >
                                                                Painting #9893
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks
                                                                5,698,368 -
                                                                5,698,943</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 400px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url(https://res.cloudinary.com/storagemanagementcontainer/image/upload/c_scale,w_445/v1649696032/nft/skater11_wriu7v.png)
                                                                        no-repeat;
                                                                    background-size: auto;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/9894"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="ma-0"
                                                                style="
                                                                    font-family: disposabledroid-bb;
                                                                    font-size: 36px;
                                                                "
                                                            >
                                                                Painting #9894
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks
                                                                5,698,944 -
                                                                5,699,519</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 400px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url(https://res.cloudinary.com/storagemanagementcontainer/image/upload/c_scale,w_446/v1649696033/nft/skater12_vbgpx6.png)
                                                                        no-repeat;
                                                                    background-size: auto;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div></div
            ></span>
        </main>

        <!-- <script
            type="text/javascript"
            src="/static/js/manifest.5f946d972125a67eabf1.js"
        ></script>
        <script
        type="text/javascript"
        src="/static/js/vendor.e47676f654e7bc42a06c.js"
        ></script>
    <script
        type="text/javascript"
        src="/static/js/app.020921c3752b3f33b6dd.js"
    ></script> -->
        <iframe
            frameborder="0"
            allowtransparency="true"
            src="https://checkout.stripe.com/v3/JdhudoUwvSFS85kPDZEQ.html?distinct_id=1bd0204f-cb2d-b561-3605-252741e44394"
            name="stripe_checkout_app"
            class="stripe_checkout_app"
        ></iframe>
    </body>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import VueMetamask from "vue-metamask";
export default {
    name: "Home",
    components: {
        VueMetamask,
    },
    data() {
        return {
            msg: "This is demo net work",
            info: [
                { id: "0", text: "John" },
                { id: "1", text: "Mary" },
            ],
        };
    },
    methods: {
        isMobile() {
            return true;
            /* return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent);
            */
        },
        onComplete(data) {
            console.log("data:", data);
        },
    },
    mounted() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute(
            "src",
            "https://www.google.com/recaptcha/api.js"
        );
        document.head.appendChild(recaptchaScript);
    },
};
</script>

<style></style>
